import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { shareReplay } from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class WordpressService {
  private _cache = {};
  private footer;
  private navigation;
  private reservations;
  private contact;
  private post;
  private _wpBase = environment.wp_base;
  private _wpOptionBase = environment.wp_options_base;
  public postsPerPage = 6;

  constructor(
    private http: HttpClient
  ) { }

  private _getCached(type: string, path: string, options = {}): Observable<any> {
    const prop = `${type}-${path}-${JSON.stringify(options)}`;
    if (this._cache[prop]) {
      return this._cache[prop];
    } else {
      this._cache[prop] = this.http.get(`${this._wpBase}/${path}`, options).pipe(shareReplay(1));
      return this._cache[prop];
    }
  }

  getPage(pageId: number): Observable<any> {
    return this._getCached(`page-${pageId}`, `pages/${pageId}`, {});
  }

  getNavigation(): Observable<any> {
    if (this.navigation) {
      return this.navigation;
    } else {
      this.navigation = this.http.get(`${this._wpOptionBase}/navigation`).pipe(shareReplay(1));
      return this.navigation;
    }
  }

  getFooter(): Observable<any> {
    if (this.footer) {
      return this.footer;
    } else {
      this.footer = this.http.get(`${this._wpOptionBase}/footer`).pipe(shareReplay(1));
      return this.footer;
    }
  }

  getReservations(): Observable<any> {
    if (this.reservations) {
      return this.reservations;
    } else {
      this.reservations = this.http.get(`${this._wpOptionBase}/reservations`).pipe(shareReplay(1));
      return this.reservations;
    }
  }

  getContact(): Observable<any> {
    if (this.contact) {
      return this.contact;
    } else {
      this.contact = this.http.get(`${this._wpOptionBase}/contact`).pipe(shareReplay(1));
      return this.contact;
    }
  }

  getJournalPosts(page: number): Observable<any> {
    return this._getCached(`journal-posts-${page}`,
      `posts?page=${ page || 1 }&per_page=${ this.postsPerPage }`, {observe: 'response'});
  }

  getJournalPost(slug: string): Observable<any> {
    this.post = this.http.get(`${this._wpBase}/posts?slug=${slug}`);
    return this.post;
  }
}
